<template>
  <div class="pages-wrap">
    <div class="flex-page">


<!--      请在通好办APP内访问-->
    </div>


    <i-loading v-if="showLoading"></i-loading>




  </div>
</template>

<script>


import {getCropInfo, sign} from "@/api/nb";
import {resetLogin,pageSign,isMobile} from "@/utils";
import * as dd from "dingtalk-jsapi";

export default {
  data() {
    return {
      showLoading: false
    };
  },
  mounted() { },
  created() {
   this.init()
  },
  methods: {
    init() {
      let that = this;
      //debugger
      // that.$router.push("/slide")
      // return
      //判断当前是被是否为PC
      if (isMobile()) {
        pageSign().then(res=> {
          dd.device.notification.showPreloader({
            text: "加载中...",
            showIcon: true
          });
          //如果是移动端
          // that.$router.push("/slide")
          getCropInfo({appKey: ''}).then(res => {
            let cropInfo = res.data;
            resetLogin(cropInfo).then(res => {
              console.log('res', res);
              dd.device.notification.hidePreloader({});
              that.$router.push("/slide")
            })
          })
        })
      } else {
        let bool = confirm('请在通好办APP内访问')
        if (bool) {
          window.close();
        }
        // pageSign().then(res=>{
        //   dd.device.notification.confirm({
        //     message: "请在通好办APP内访问",
        //     title: "提示",
        //     buttonLabels: ['确定'],
        //     onSuccess: function (result) {
        //       window.close();
        //     },
        //     onFail: function (err) {
        //     }
        //   })
        // })
      }



    },
    //paraName 等找参数的名称
    getUrlParam(paraName) {
      // var url = document.location.toString();
      var url = window.location.href.toString();
      console.log(url);
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        console.log(arrPara);
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      }
      else {
        return "";
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
